module.exports = "pegasus/assets/social-card.png";